import Footer from "../../components/Footer/Footer"
import Header from "../../components/Header/Header"

import "../../components/Content/Content.scss";
import { useEffect, useState } from "react";
import { fetchCarsDump } from "../../services/api";
import CarCardItem from "../../components/CarCardItem/CarCardItem";

import "./Listing.scss";
import Select from "../../components/Select/Select";
import { scrollToTop, useForceUpdate } from "../../services/shared";
import ListingFilters from "../../components/ListingFilters/ListingFilters";
import ListingLoader from "../../components/ListingLoader";

import SortIcon from '../../assets/images/icons/sort.svg';
import CloseIcon from '../../assets/images/icons/close.svg';
import FilterIcon from '../../assets/images/icons/filter.svg';
import MsrpDisclaimer from "../../components/MsrpDisclaimer/MsrpDisclaimer";
import { filters, sortingOptions } from "../../constants";

const DEFAULT_PAGE_TITLE = 'Popular Cars';

const Listing = ()=>{
    const url = new URL(window.location);
    const params = url.searchParams;
    const sortOptionFromUrl = sortingOptions.find(option=>{
        return option.property?.toUpperCase() === params.get('sort')?.toUpperCase() && 
            (
                params.get('order')?
                option.order?.toUpperCase() === params.get('order')?.toUpperCase():
                option.order?.toUpperCase() === 'DESC'
            )
        
    });
    const [pageTitle, setPageTitle] = useState(params.get('title') || DEFAULT_PAGE_TITLE);
    const [masterCarList, setMasterCarList] = useState([]);
    const [displayCarList, setDisplayCarList] = useState([]);
    const [selectedSort, setSelectedSort] = useState(sortOptionFromUrl || sortingOptions[0]);
    const [makeOptions, setMakeOptions] = useState([]);
    const [bodyTypeOptions, setBodyTypeOptions] = useState([]);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [showMobileSorting, setShowMobileSorting] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [customMakeOpen, setCustomMakeOpen] = useState(false);
    const forceUpdate = useForceUpdate();
    
    useEffect(() => {
        (params.get('tmpl') === 't1' || params.get('tmpl') === 't2') && window.location.pathname === "/listing" ? document.body.classList.add('custom-make') : document.body.classList.remove('custom-make');
        params.get('tmpl') === 't2' && window.location.pathname === "/listing" ? document.body.classList.add('custom-range') : document.body.classList.remove('custom-range');
        params.get('makeFilters') ? setCustomMakeOpen(true) : setCustomMakeOpen(false);
    }, []);

    useEffect(()=>{
        setLoadingList(true);
        fetchCarsDump().then(cars=>{
            setLoadingList(false);
            const carList = []
            const makeList = filters.find(filter=>filter.name === "Make").options;
            filters.push({
                    name: "Body Type",
                    urlParamName: "bodyFilters",
                    property: 'segment',
                    options: []
                }
                )

            const bodyList = filters.find(filter=>filter.name === "Body Type").options;
            const oem = params.get('oem')?.toUpperCase();
            cars.forEach(car=>{
                 // if(carList.findIndex(_=>_.model === car.model && _.make === car.make) == -1){
                    if(oem){
                        if(car.dealershipOem?.toUpperCase() === oem){
                            carList.push(car);
                        }
                    }else{
                        carList.push(car);
                    }

                if(car.make && makeList.findIndex(_=>_.name === car.make) === -1){
                    const makesInUrl = params.get('makeFilters')?.split(',');
                    makeList.push({
                        name: car.make,
                        active: makesInUrl?.findIndex(_=>_.toUpperCase() === car.make.toUpperCase()) > -1
                    })
                }
                if(car.segment && bodyList.findIndex(_=>_.name === car.segment) === -1){
                    const bodyTypesInUrl = params.get('bodyFilters')?.split(',');
                    bodyList.push({
                        name: car.segment,
                        active: bodyTypesInUrl?.findIndex(_=>_.toUpperCase() === car.segment.toUpperCase()) > -1
                    })
                }
            })
            setMasterCarList(carList);
            setMakeOptions(makeList);
            setBodyTypeOptions(bodyList);
        },()=>{
            setLoadingList(false);
        })
    },[])

    useEffect(()=>{
        setDisplayCarList(filterAndSortList(filters,selectedSort.property, selectedSort.order))
        forceUpdate();
    },[selectedSort, masterCarList])

    function clearAllFilters(){
        filters.forEach(filter=>{
            filter.options.forEach(option=>{
                option.active = false;
            })
        })
        setDisplayCarList(filterAndSortList(filters,selectedSort.property, selectedSort.order))
    }

    function filterAndSortList(filters,sortColumn,order="asc"){

        params.set('sort',sortColumn)
        params.set('order',order)
        let temp = masterCarList.sort((a,b)=>{
            return order === "asc"?
                parseFloat(a[sortColumn])-parseFloat(b[sortColumn]):
                parseFloat(b[sortColumn])-parseFloat(a[sortColumn])
        });
        filters.map(filter=>{
            temp = temp.filter(car=>{
                const activeOptions = filter.options.filter(_=>_.active);
                if(activeOptions.length){
                    if(filter.property === 'price'){
                        params.set('minPrice',activeOptions[0].min)
                        params.set('maxPrice',activeOptions[activeOptions.length-1].max)
                    }else{
                        params.set(filter.urlParamName,activeOptions.map(_=>_.name).join(','))
                    }
                    return fitsInOption(car[filter.property],activeOptions)
                }else{
                    if(filter.property === 'price'){
                        params.delete('minPrice');
                        params.delete('maxPrice');
                    }else{
                        params.delete(filter.urlParamName);
                    }
                }
                return true;
            })
        })
        window.history.pushState({},'',url)
        return temp;
    }
    function fitsInOption(value, activeOptions){
        for(let option of activeOptions){
            if(option.min || option.max){
                if(option.min <= parseFloat(value) && option.max >= parseFloat(value)){
                    return true;
                }
            }
            if(option.name && value && option.name.toString().toUpperCase() === value.toString().toUpperCase()){
                return true;
            } 
            
        }
        return false;
    }

    function hasFilterApplied(){
        let found = false
        filters.forEach(filter=>{
            filter.options.forEach(option=>{
                if(option.active){
                    found = true;
                }
            })
        })
        return found;
    }
    return (
        <>
            <Header baseUrl='/listing' showBanner={false} inverseLogo={true}></Header>
            <div className="listing-wrapper">
                <div className="container flex listing-container" >
                    <div className={`left-container ${showMobileFilters?'show':''} ${customMakeOpen ? 'd-none':''}`}>
                        <h1 className="title">Select a Brand & <span>Discover the Car</span> that Fits your Needs</h1>
                        <p className="desc">Top 4 Best Sellers - Find Your Perfect Car Today!</p>

                        <ListingFilters 
                            filters={filters}
                            makeOptions={makeOptions}
                            bodyTypeOptions={bodyTypeOptions}
                            closeFilters={()=>{
                                setShowMobileFilters(false);
                            }}
                            filterChanged={()=>{
                                setPageTitle(DEFAULT_PAGE_TITLE);
                                params.delete('title');
                                setDisplayCarList(filterAndSortList(filters,selectedSort.property,selectedSort.order))
                                scrollToTop();
                            }}
                            toggleResults={()=>{
                                setCustomMakeOpen(true);
                            }}
                        ></ListingFilters>
                    </div>
                    <div className={`right-container flex-auto ${customMakeOpen ? 'show':''}`}>
                    <h2>Get the Best Pricing for <span>Cars</span> Near You!</h2>
                        {(params.get('tmpl') === 't1' || params.get('tmpl') === 't2') && customMakeOpen && <ListingFilters 
                            filters={filters}
                            makeOptions={makeOptions}
                            bodyTypeOptions={bodyTypeOptions}
                            closeFilters={()=>{
                                setShowMobileFilters(false);
                            }}
                            filterChanged={()=>{
                                setPageTitle(DEFAULT_PAGE_TITLE);
                                params.delete('title');
                                setDisplayCarList(filterAndSortList(filters,selectedSort.property,selectedSort.order))
                                scrollToTop();
                            }}
                            toggleResults={()=>{
                                setCustomMakeOpen(true);
                            }}
                        ></ListingFilters>}
                        <div className="right-container-filter flex w-full items-center mb-16px">
                            <div className="flex-auto">
                                <div className="page-title">{pageTitle}</div>
                                <div className="page-sub-title">Select a car to get best deals</div>
                            </div>
                            <div className={`sorting-control-container ${showMobileSorting?'show':''}`}>
                                <Select className="compact" options={sortingOptions} selected={selectedSort.value} label="Sort by" onChange={(option)=>{
                                    window.dataLayer.push({
                                        'event': 'Changed sorting',
                                        'event_category': 'Sorting',
                                        'event_label': option.name,
                                        'event_value': option.order,
                                        'event_action': 'Change'
                                    })
                                    setSelectedSort(option);
                                }}
                                ></Select>
                                <div className="sorting-control-container--backdrop" onClick={()=>{
                                    window.dataLayer.push({
                                        'event': 'Open/Close mobile sorting',
                                        'event_category': 'Mobile backdrop',
                                        'event_action': 'Close'
                                    })
                                    setShowMobileSorting(false);
                                }}></div>
                                <div className="sorting-control-container--mobile">
                                    <div className="sorting-control-container--mobile--header">
                                        <span>Sort By</span>
                                        <span className="sorting-control-container--mobile--header--close" onClick={()=>{
                                            setShowMobileSorting(false);
                                        }}><img src={CloseIcon}/></span>
                                    </div>
                                    <ul className="sorting-control-container--mobile--list">
                                        {sortingOptions.map(option=>(
                                            <li 
                                                onClick={()=>{
                                                    window.dataLayer.push({
                                                        'event': 'Changed sorting',
                                                        'event_category': 'Sorting',
                                                        'event_label': option.name,
                                                        'event_value': option.order,
                                                        'event_action': 'Change'
                                                    })
                                                    setSelectedSort(option);
                                                    setShowMobileSorting(false);
                                                }} 
                                                className={`${option.name === selectedSort.name?'active':''}`}>{option.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                               
                            </div>
                        </div>            
                        {
                            displayCarList.length === 0 && loadingList && 
                            <ListingLoader></ListingLoader>
                        }
                        {
                            displayCarList.length === 0 && !loadingList &&
                            <div className="no-data-container">
                                <div className="no-data-container--header">Sorry! No cars found.</div>
                                <div className="no-data-container--sub-header">
                                    Please try
                                    <a onClick={()=>{
                                        window.dataLayer.push({
                                            'event': 'Changed filters',
                                            'event_category': 'No data',
                                            'event_label': 'All',
                                            'event_action': 'Clear'
                                        })
                                        clearAllFilters();
                                    }}> clearing filters.</a>
                                </div>
                            </div>
                        }
                        <ul className="listing-container--car-list">
                           
                           
                            {
                                displayCarList.map((_,i)=>
                                   i<12 && (<li key={i}>
                                        <CarCardItem ctaClass="primary" item={_} itemAction={(car, type)=>{
                                            window.dataLayer.push({
                                                'event': 'List item - Get offer',
                                                'eventCallback': () => {
                                                    const params = new URLSearchParams(window.location.search)
                                                    window.open(`/deals?make=${car.make}&model=${car.model}&year=${car.year}&baseUrl=/listing&${params.toString()}`);
                                                },
                                                'eventTimeout': 2000,
                                                'event_make': car.make,
                                                'event_model': car.model,
                                                'event_year': car.year,
                                                'event_label': type
                                            })
                                            
                                        }}/>
                                    </li>
                                
                                ))
                            }
                        </ul>
                    </div>
                </div>

                <MsrpDisclaimer></MsrpDisclaimer>

                <ul className="mobile-bottom-actions">
                    <li onClick={()=>{
                        window.dataLayer.push({
                            'event': 'Open/Close mobile sorting',
                            'event_category': 'Mobile backdrop',
                            'event_action': 'Open'
                        })
                        setShowMobileSorting(true);
                    }}>
                        <img src={SortIcon}/>
                        SORT
                    </li>
                    <li onClick={()=>{
                        window.dataLayer.push({
                            'event': 'Open/Close mobile filters',
                            'event_category': 'Filters',
                            'event_label': 'Back icon',
                            'event_action': 'Close'
                        })
                        setShowMobileFilters(true);
                    }} >
                        
                        <img src={FilterIcon}/>
                        
                        FILTERS
                        {
                            hasFilterApplied() &&
                            <span className="dot"></span>
                        }
                    </li>
                </ul>
                
            </div>
            <Footer></Footer>
        </>
    )
}

export default Listing